import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    processorList: []
  },
  getters: {},
  mutations: {
    setProcessorList(state, payload) {
      state.processorList = payload;
    }
  },
  actions: {
    list({ commit }, coin) {
      api.getProcessorList(coin).then(({ data }) => {
        commit('setProcessorList', data);
      });
    },
    updatePendingHeight(context, data) {
      return api.updatePendingHeight(data);
    },
    updateConfimedHeight(context, data) {
      return api.updateConfimedHeight(data);
    }
  }
};

appStore.registerModule('processorConfigSetting', store);
